import { c as _c } from "react/compiler-runtime";
import { NodeViewContent, NodeViewWrapper } from "@tiptap/react";
import { htmlFallbackProps } from "./element";
interface Props {
  attrs: Record<string, unknown>;
  updateAttrs: (attrs: Record<string, unknown>) => void;
  selected: boolean;
}

/**
 * A preserved element on the canvas.
 *
 * `NodeViewContent` renders as the element itself with the element's own
 * attributes and styles, so what the composer shows is what the send renderer
 * emits — both read the same props from `htmlFallbackProps`.
 *
 * Class-based styling is the exception, and a deliberate one: a `<style>` block
 * survives into the document and into the sent email, but its rules are not in
 * the console's page, so content styled by class shows here unstyled. Scoping
 * that CSS into the editor is its own piece of work.
 */
export function HtmlFallbackTiptapView(t0) {
  const $ = _c(8);
  const {
    attrs,
    selected
  } = t0;
  const tag = (attrs.tag as string || "div") as "div";
  const t1 = selected || undefined;
  let t2;
  if ($[0] !== attrs) {
    t2 = htmlFallbackProps(attrs);
    $[0] = attrs;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2 || $[3] !== tag) {
    t3 = <NodeViewContent as={tag} {...t2} />;
    $[2] = t2;
    $[3] = tag;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <NodeViewWrapper data-block-type="htmlFallback" data-selected={t1}>{t3}</NodeViewWrapper>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}

/**
 * Markup with nothing to draw: a `<style>` block or a conditional comment.
 * It is invisible in the inbox, so it is invisible here too — but it is still
 * in the document, and still in what gets sent.
 */
export function HtmlRawTiptapView() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <NodeViewWrapper data-block-type="htmlRaw" contentEditable={false} style={{
      display: "none"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}